import { Box, Skeleton } from "@mui/material";

interface GanttSkeletonProps {
	laneCount: number;
	rowHeight: number;
	headerHeight?: number;
	assetCellWidth?: number;
}

export const GanttSkeleton = ({
	laneCount,
	rowHeight,
	headerHeight = 50,
	assetCellWidth = 160,
}: GanttSkeletonProps) => {
	const lanes = Array.from({ length: laneCount });

	return (
		<Box sx={{ display: "flex", width: "100%", overflow: "hidden" }}>
			<Box sx={{ width: assetCellWidth, flexShrink: 0 }}>
				<Box sx={{ height: headerHeight }} />
				{lanes.map((_, i) => (
					<Box
						key={i}
						sx={{
							height: rowHeight,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							px: 1.5,
							bgcolor: i % 2 === 1 ? "action.hover" : "transparent",
						}}
					>
						<Skeleton
							variant="rounded"
							animation="wave"
							width="85%"
							height={rowHeight * 0.5}
						/>
					</Box>
				))}
			</Box>

			<Box sx={{ flex: 1, minWidth: 0 }}>
				<Box
					sx={{
						height: headerHeight,
						display: "flex",
						alignItems: "center",
						px: 1,
					}}
				>
					<Skeleton
						variant="text"
						animation="wave"
						width="100%"
						height={headerHeight * 0.5}
					/>
				</Box>
				{lanes.map((_, i) => (
					<Box
						key={i}
						sx={{
							height: rowHeight,
							display: "flex",
							alignItems: "center",
							px: 1,
							bgcolor: i % 2 === 1 ? "action.hover" : "transparent",
						}}
					>
						<Skeleton
							variant="rounded"
							animation="wave"
							width="100%"
							height={rowHeight * 0.4}
						/>
					</Box>
				))}
			</Box>
		</Box>
	);
};
